import { render, staticRenderFns } from "./StaffUploadApplicationFiles.vue?vue&type=template&id=48a9571f&scoped=true&"
import script from "./StaffUploadApplicationFiles.vue?vue&type=script&lang=js&"
export * from "./StaffUploadApplicationFiles.vue?vue&type=script&lang=js&"
import style0 from "./StaffUploadApplicationFiles.vue?vue&type=style&index=0&id=48a9571f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9571f",
  null
  
)

export default component.exports